import { IconProps } from './types';

export function Globe({ size, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="currentColor"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9 18.6997C14.5658 17.035 15 14.6668 15 12C15 9.33323 14.5658 6.96497 13.9 5.30032C13.5659 4.46523 13.1932 3.85653 12.8304 3.47296C12.4697 3.0915 12.1887 3 12 3C11.8113 3 11.5303 3.0915 11.1696 3.47296C10.8068 3.85653 10.4341 4.46523 10.1 5.30032C9.43419 6.96497 9 9.33323 9 12C9 14.6668 9.43419 17.035 10.1 18.6997C10.4341 19.5348 10.8068 20.1435 11.1696 20.527C11.5303 20.9085 11.8113 21 12 21C12.1887 21 12.4697 20.9085 12.8304 20.527C13.1932 20.1435 13.5659 19.5348 13.9 18.6997ZM12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2C9.79086 2 8 6.47715 8 12C8 17.5228 9.79086 22 12 22Z"
        fill="currentColor"
      />

      <path fillRule="evenodd" clipRule="evenodd" d="M21 9H3V8H21V9Z" fill="currentColor" />

      <path fillRule="evenodd" clipRule="evenodd" d="M21 15H3V14H21V15Z" fill="currentColor" />
    </svg>
  );
}
